import classNames from 'classnames';
import { Spinner } from 'app/shared/components/spinner/spinner.component';
import { IconType } from 'react-icons';
import { StatValue } from 'app/agriculture/components/StatDisplay/StatValue/StatValue';
import './StatDisplay.scss';
import { ReactNode } from 'react';
import { statDisplayFormat } from 'app/agriculture/components/StatDisplay/statDisplayFormat';

export interface StatDisplayProps {
    id?: string;
    name?: string | null;
    value?: ReactNode;
    tooltip?: string;
    emptyStateMessage?: string;
    unit?: string;
    isCalculating?: boolean;
    className?: string;
    decimalPlaces?: number;
    Icon?: IconType;
}

export function StatDisplay({
    id,
    className,
    name,
    value,
    tooltip,
    unit,
    isCalculating = false,
    emptyStateMessage = 'No data',
    decimalPlaces = 0,
    Icon,
}: Readonly<StatDisplayProps>) {
    return (
        <div
            id={id}
            data-testid={id ?? 'StatDisplay'}
            className={classNames(className, 'StatDisplay')}
            title={tooltip}
        >
            {name == null ? null : <label className="StatDisplay__name">{name}</label>}

            {isCalculating ? (
                <Spinner show={true} fontSize={1.5} />
            ) : (
                <div className="StatDisplay__content">
                    {!Icon ? null : <Icon className="StatDisplay__icon" />}
                    {value == null ? (
                        emptyStateMessage
                    ) : (
                        <StatValue className="StatDisplay__value" unit={unit}>
                            {statDisplayFormat(value, decimalPlaces)}
                        </StatValue>
                    )}
                </div>
            )}
        </div>
    );
}
